<template>
  <label v-if="errorBag.firstByRule(control, rule)">{{ $t(i18nKey) }}</label>
</template>

<script>
import { ErrorBag } from 'vee-validate'

export default {
  name: 'ValidationTip',
  props: {
    errorBag: {
      type: ErrorBag,
      required: true
    },
    control: {
      type: String,
      required: true
    },
    rule: {
      type: String,
      required: true
    },
    i18nKey: {
      type: String,
      required: true
    }
  }
}
</script>
